export enum WTMTab {
  TrackerList = 0,
  HistoricalScans = 1,
}

export const WTM_TYPICAL_LOADS_COPY =
  "Usually added through a tag manager or directly in site code. Commonly appears as a script or image tag.";

export const WTM_SIGN_IN_HINT =
  "Sign in to see exactly where this was found on your site.";

export const WTM_SHARE_DISCLOSURE =
  "Send one link with the tracker and the fix. Anyone can open it, no account needed.";

export const WTM_SHARE_NOTE_MAX_LENGTH = 2000;
